import { apiClient } from '../lib/query/apiClient';

export const useMinSideLink = () => {
  const { data } = apiClient.useQuery('get', '/api/v1/Session/GetHeaderData');
  return data?.links?.homePage;
};
